"use client";
import React from "react";

import { Box, BoxSx } from "../../foundations";
import { SliderPropsWithDefaults } from "./types";

interface SliderTrackProps {
  fillClassName?: string;
  leaveSpaceAtEnd?: boolean;
  leaveSpaceAtStart?: boolean;
  roundEnd?: boolean;
  roundStart?: boolean;
  slider: SliderPropsWithDefaults;
  trackEnd: number;
  trackStart: number;
}

export const SliderTrack: React.FC<SliderTrackProps> = ({
  fillClassName,
  leaveSpaceAtEnd,
  leaveSpaceAtStart,
  roundEnd = false,
  roundStart = false,
  slider,
  trackEnd,
  trackStart
}) => {
  const length = slider.max - slider.min;
  const left = React.useCallback<Extract<BoxSx["left"], Function>>(
    ({ sizes }) => {
      if (leaveSpaceAtStart) {
        return `calc(${((trackStart - slider.min) / length) * 100}% + ${sizes[1] + sizes[1] / 2}px)`;
      } else {
        return `${((trackStart - slider.min) / length) * 100}%`;
      }
    },
    [leaveSpaceAtStart, length, slider, trackStart]
  );
  const width = React.useCallback<Extract<BoxSx["width"], Function>>(
    ({ sizes }) => {
      const trackLength = trackEnd - trackStart;

      if (leaveSpaceAtEnd && leaveSpaceAtStart) {
        return `calc(${(trackLength / length) * 100}cqw - ${sizes[3]}px)`;
      } else if (leaveSpaceAtEnd || leaveSpaceAtStart) {
        return `calc(${(trackLength / length) * 100}cqw - ${sizes[1] + sizes[1] / 2}px)`;
      } else {
        return `${(trackLength / length) * 100}cqw`;
      }
    },
    [leaveSpaceAtEnd, leaveSpaceAtStart, length, trackEnd, trackStart]
  );

  return (
    <Box
      as="span"
      className={fillClassName}
      sx={{
        backgroundColor: fillClassName
          ? undefined
          : "slider-surface-not-selected",
        borderEndEndRadius: roundEnd ? "radius-1" : null,
        borderEndStartRadius: roundStart ? "radius-1" : null,
        borderStartEndRadius: roundEnd ? "radius-1" : null,
        borderStartStartRadius: roundStart ? "radius-1" : null,
        display: "block",
        height: 2,
        left,
        position: "absolute",
        top: 3,
        width
      }}
    />
  );
};
